import { createPersistedStore } from "./createPersistedStore";
import { Employee } from "../models/employees/Employees";

type UserState = {
  loggedInEmployee?: Employee;
  employees?: Employee[];
};

type UserAction = {
  setLoggedInEmployee: (employee?: Employee) => void;
  setEmployees: (employees: Employee[]) => void;
  reset: () => void;
};

const defaultState: UserState = {
  loggedInEmployee: undefined,
  employees: undefined,
};

export const useUserStore = createPersistedStore<UserState, UserAction>(
  defaultState,
  (set) => ({
    setLoggedInEmployee(id) {
      set((state: any) => {
        state.loggedInEmployee = id;
      });
    },
    setEmployees(employees) {
      set((state: any) => {
        state.employees = employees;
      });
    },
    reset() {
      set(() => defaultState);
    },
  }),
  "user",
  (state) => ({
    loggedInUserId: state.loggedInEmployee,
    employees: state.employees,
  })
);